import { Injectable, Type } from '@angular/core';
import { NbDialogConfig, NbDialogRef, NbDialogService } from '@nebular/theme';
import { AlertComponent } from '../components/dialog/alert/alert.component';

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  constructor(private dialog: NbDialogService) {}

  alert(title?: string, message?: string): NbDialogRef<AlertComponent> {
    let confirm: NbDialogRef<AlertComponent> = this.dialog.open(AlertComponent, {
      context: {
        confirm: false,
        title: title || '알림 메시지',
        message: message || '잘 처리되었습니다.',
      },
    });

    return confirm;
  }

  confirm(title?: string, message?: string): NbDialogRef<AlertComponent> {
    return this.dialog.open(AlertComponent, {
      context: {
        confirm: true,
        title: title || '확인 메시지',
        message: message || '선택한 작업을 진행하시겠습니까?',
      },
    });
  }

  open<T>(component: Type<T>, context: Partial<NbDialogConfig<Partial<T> | string>>) {
    let dialog = this.dialog.open(component, context);

    return dialog;
  }
}
